import RevenueReportTypes from "./revenueReport.types";

export const setRevReportSelectedFilter = (filters) => ({
  type: RevenueReportTypes.SET_REV_REPORT_SELECTED_FILTER,
  payload: filters
});
